// 默认验证码集合
const codeData = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0'
];

// 随机验证码
const randomNum = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

// 随机生成验证码字符串
export const makeCode = (data = codeData, len = 4) => {
  let identifyCode = '';
  for (let i = 0; i < len; i++) {
    identifyCode += data[randomNum(0, data.length - 1)];
  }
  return identifyCode;
};